import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
} from '@mui/x-data-grid';
import { ToolbarSearchInput } from '@components/DataGrid/ToolbarSearchInput';

declare module '@mui/x-data-grid' {
  interface ToolbarPropsOverrides {
    searchText: string;
    onSearchChange: (value: string) => void;
  }
}

interface ClearancesToolbarProps {
  searchText: string;
  onSearchChange: (newValue: string) => void;
};

const ClearancesToolbar = ({
  searchText,
  onSearchChange
}: ClearancesToolbarProps) => {
  return (
    <GridToolbarContainer
      data-testid='custom-toolbar'
      sx={{ padding: 1, justifyContent: 'space-between' }}
    >
      <ToolbarSearchInput
        value={searchText}
        onChange={(newValue) => onSearchChange(newValue as unknown as string)}
      />
      <GridToolbarColumnsButton />
    </GridToolbarContainer>
  );
};

export default ClearancesToolbar;
